import React from 'react';

import Countdown from '../Countdown/Countdown';
import EventMessages from '../EventMessages/EventMessages';
import EventTitle from '../EventTitle/EventTitle';

import styles from './EventDetail.scss';

const EventDetails: React.FC = () => (
  <div className={styles.root}>
    <EventTitle />
    <EventMessages />
    <Countdown />
  </div>
);
export default EventDetails;
